import * as React from 'react';
import { SignInPane } from '../../components/organisms/signin/SignInPane';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../routes';
import { RouteComponentProps } from 'react-router';
import { observable, makeObservable } from 'mobx';
import { parseQueryParams } from '../../types/location';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { observer } from 'mobx-react';

type Props = RouteComponentProps;

export const SignInPage = withNavigation(NavigationSpecs.application())(
  observer(
    class SignInPage extends React.Component<Props> {
      redirectUrl = null;

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          redirectUrl: observable,
        });
      }

      componentDidMount(): void {
        const { redirect_url } = parseQueryParams(this.props.location);
        this.redirectUrl = redirect_url;
        GlobalStatesV3.currentUser.reloadUser();
      }

      render() {
        return (
          <SignInPane
            redirectUrl={this.redirectUrl}
            supportNewUser={true}
            onNewUserPreferred={() => GlobalStatesV3.routing.push(V3Routes.applicationUserInfo().stringify())}
          />
        );
      }
    }
  )
);
